import React from 'react';
import './CustomChartCard.css';

const CustomChartCard = ({ title, children, className }) => {
    return (
        <div className={`custom-card ${className || ""}`}>
            {title && <h2 className="custom-card-title">{title}</h2>}
            {children}
        </div>
    );
};

export default CustomChartCard;


